interface IComparable {
    id: number
    target: string
}

function specCompare(a: IComparable, b: IComparable) {
    if (a.target > b.target) {
        return 1
    }

    if (a.target < b.target) {
        return -1
    }

    if (a.id > b.id) {
        return 1
    }

    if (a.id < b.id) {
        return -1
    }

    return 0
}

export function SD_equal(a: IComparable[], b: IComparable[]) {
    if (a.length !== b.length) {
        return false
    }

    const sortedA = [].concat(a).sort(specCompare)
    const sortedB = [].concat(b).sort(specCompare)

    for (let i = 0; i < sortedA.length; ++i) {
        if (sortedA[i].target !== sortedB[i].target) {
            return false
        }

        if (sortedA[i].id !== sortedB[i].id) {
            return false
        }
    }

    return true
}
